@use '@/styles/tokens' as *;

.containerReset {
  padding: 0 !important;
  border-radius: var(--radius-xl) !important;
  overflow: hidden;
  box-shadow: var(--shadow-overlay) !important;
}

.modal :global(.ant-modal-content) {
  background: var(--surface-card);
}

@media (prefers-reduced-motion: reduce) {
  .modal :global(.ant-modal),
  .modal :global(.ant-modal-mask) {
    animation-duration: 0.001ms !important;
    transition-duration: 0.001ms !important;
  }
}
